import { createRouter, createWebHashHistory } from 'vue-router'

const router = createRouter({
    history: createWebHashHistory(),
    routes: [
        // 我的订单
        {
            path: '/myOrder',
            name: 'myOrder',
            component: () =>
                import(
                    /* webpackChunkName: "myOrder" */ '@/views/myOrder/MyOrder.vue'
                ),
            meta: {
                title: '我的订单',
            },
        },
        // 注销账号
        {
            path: '/accountCancellation',
            name: 'accountCancellation',
            component: () =>
                import(
                    /* webpackChunkName: "accountCancellation" */ '@/views/accountCancellation/AccountCancellation.vue'
                ),
            meta: {
                title: '注销账号',
            },
        },
        // 账户与安全
        {
            path: '/account',
            name: 'account',
            component: () =>
                import(
                    /* webpackChunkName: "account" */ '@/views/account/Account.vue'
                ),
            meta: {
                title: '账户与安全',
            },
        },

        // 修改密码
        {
            path: '/changePassword',
            name: 'changePassword',
            component: () =>
                import(
                    /* webpackChunkName: "changePassword" */ '@/views/changePassword/ChangePassword.vue'
                ),
            meta: {
                title: '修改密码',
            },
        },
        {
            path: '/changePwd',
            name: 'changePwd',
            component: () =>
                import(
                    /* webpackChunkName: "changePwd" */ '@/views/changePassword/Changepwd.vue'
                ),
            meta: {
                title: '修改密码',
            },
        },
        //更改手机
        {
            path: '/changePhoneNumber',
            name: 'changePhoneNumber',
            component: () =>
                import(
                    /* webpackChunkName: "changePhoneNumber" */ '@/views/changePhoneNumber/ChangePhoneNumber.vue'
                ),
            meta: {
                title: '更改手机',
            },
        },
        {
            path: '/changePhone',
            name: 'changePhone',
            component: () =>
                import(
                    /* webpackChunkName: "changePhone" */ '@/views/changePhoneNumber/Changephone.vue'
                ),
            meta: {
                title: '更改手机',
            },
        },
        //个人信息保护政策
        {
            path: '/informationSafety',
            name: 'informationSafety',
            component: () =>
                import(
                    /* webpackChunkName: "informationSafety" */ '@/views/informationSafety/InformationSafety.vue'
                ),
            meta: {
                title: '信息安全',
            },
        },
        //隐私协议
        {
            path: '/privacyAgreement',
            name: 'privacyAgreement',
            component: () =>
                import(
                    /* webpackChunkName: "privacyAgreement" */ '@/views/informationSafety/PrivacyAgreement.vue'
                ),
            meta: {
                title: '隐私协议',
            },
        },
        {
            path: '/privacyAgreementNoEncrypt',
            name: 'privacyAgreementNoEncrypt',
            component: () =>
                import(
                    /* webpackChunkName: "PrivacyAgreementNoEncrypt" */ '@/views/informationSafety/PrivacyAgreementNoEncrypt.vue'
                ),
            meta: {
                title: '隐私协议',
            },
        },
        //儿童隐私协议
        {
            path: '/childrenPrivacyAgreement',
            name: 'childrenPrivacyAgreement',
            component: () =>
                import(
                    /* webpackChunkName: "childrenPrivacyAgreement" */ '@/views/informationSafety/ChildrenPrivacyAgreement.vue'
                ),
            meta: {
                title: '儿童隐私协议',
            },
        },
        //注册协议
        {
            path: '/registerAgreement',
            name: 'registerAgreement',
            component: () =>
                import(
                    /* webpackChunkName: "registerAgreement" */ '@/views/informationSafety/RegisterAgreement.vue'
                ),
            meta: {
                title: '会员注册开通协议',
            },
        },
        //信息安全保障措施说明
        {
            path: '/safety',
            name: 'safety',
            component: () =>
                import(
                    /* webpackChunkName: "safety" */ '@/views/informationSafety/Safety.vue'
                ),
            meta: {
                title: '信息安全保障措施说明',
            },
        },

        // 注销账号 - 结果页
        {
            path: '/cancellationResult',
            name: 'cancellationResult',
            component: () =>
                import(
                    /* webpackChunkName: "CancellationResult" */ '@/views/accountCancellation/CancellationResult.vue'
                ),
            meta: {
                title: '注销账号',
            },
        },
        // 个人信息
        {
            path: '/personalInfo',
            name: 'personalInfo',
            component: () =>
                import(
                    /* webpackChunkName: "personalInfo" */ '@/views/PersonalInfo/PersonalInfo.vue'
                ),
            meta: {
                title: '个人信息',
            },
        },
        // 个人信息 - 输入信息
        {
            path: '/personalInfoEdit',
            name: 'personalInfoEdit',
            component: () =>
                import(
                    /* webpackChunkName: "personalInfoEdit" */ '@/views/PersonalInfo/PersonalInfoEdit.vue'
                ),
            // meta: {
            //     title: '注销账号',
            // },
        },
        // 实名认证
        {
            path: '/identityVerification',
            name: 'identityVerification',
            component: () =>
                import(
                    /* webpackChunkName: "IdentityVerification" */ '@/views/IdentityVerification/IdentityVerification.vue'
                ),
            meta: {
                title: '实名认证',
            },
        },
        // 实名认证
        {
            path: '/identityVerificationGab',
            name: 'identityVerificationGab',
            component: () =>
                import(
                    /* webpackChunkName: "IdentityVerification" */ '@/views/IdentityVerification/IdentityVerificationGab.vue'
                ),
            meta: {
                title: '实名认证',
            },
        },
        // 实名认证 - 认证结果
        {
            path: '/verificationResult',
            name: 'verificationResult',
            component: () =>
                import(
                    /* webpackChunkName: "VerificationResult" */ '@/views/IdentityVerification/VerificationResult.vue'
                ),
            meta: {
                title: '实名认证',
            },
        },
        // 乐健康 - 健康咨询
        {
            path: '/leHealthList',
            name: 'leHealthList',
            component: () =>
                import(
                    /* webpackChunkName: "LeHealthList" */ '@/views/LeHealthList/LeHealthList.vue'
                ),
            meta: {
                title: '健康资讯',
                keepAlive: true,
            },
            beforeEnter: (to, from) => {
                console.info('beforeEnter')
            }
        },
        //投保成功
        {
            path: '/successfullyInsured',
            name: 'successfullyInsured',
            component: () =>
                import(
                    /* webpackChunkName: "successfullyInsured" */ '@/views/successfullyInsured/SuccessfullyInsured.vue'
                ),
            meta: {
                title: '投保成功',
            },
        },
        //投保成功
        {
            path: '/successQuestion',
            name: 'successQuestion',
            component: () =>
                import(
                    /* webpackChunkName: "successQuestion" */ '@/views/successQuestion/SuccessQuestion.vue'
                ),
            meta: {
                title: '提交成功',
            },
        },
        {
            path: '/slideBar',
            name: 'slideBar',
            component: () =>
                import(
                    /* webpackChunkName: "slide" */ '@/views/slideBar/index.vue'
                ),
            meta: {
                title: '阿里云滑块',
            },
        },
         // 消息中心
         {
            path: '/message',
            name: 'message',
            component: () =>
                import(
                    /* webpackChunkName: "message" */ '@/views/message/Message.vue'
                ),
            meta: {
                title: '消息中心',
            },
        },
        {
            path: '/messageList',
            name: 'messageList',
            component: () =>
                import(
                    /* webpackChunkName: "messageList" */ '@/views/message/MessageList.vue'
                ),
            meta: {
                title: '消息中心',
            },
        },    
    ],
})

export default router
